import React, { useState, useEffect } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const TrainingBarChart = ({ trainingId, trainingCards }) => {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuizData = async () => {
      try {
        const response = await fetch(`https://api.insightos.co.uk/api/getquiz/${trainingId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        });
        const quizData = await response.json();
        const questions = quizData.data;

        const trainingCard = trainingCards.find(card => card.trainingId == trainingId);
        if (!trainingCard) {
          console.error("No training data found.");
          setLoading(false);
          return;
        }

        let attempts = [];
        trainingCard.results.forEach(result => {
          if (result.attempts && Array.isArray(result.attempts)) {
            attempts = attempts.concat(result.attempts);
          } else {
            attempts.push(result);
          }
        });

        const formattedData = questions.map((q, i) => {
          let correct = 0;
          let incorrect = 0;

          attempts.forEach(attempt => {
            const wrongIds = attempt.wrongAnswerIds.split(",").map(id => id.trim());
            if (wrongIds.includes(q.id.toString())) {
              incorrect++;
            } else {
              correct++;
            }
          });

          return {
            questionNumber: `Q${i + 1}`, // Show Q1, Q2, etc.
            fullQuestion: q.Question, // Store full question for tooltip
            Correct: correct,
            Incorrect: incorrect,
          };
        });

        setChartData(formattedData);
      } catch (error) {
        console.error("Error fetching quiz data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchQuizData();
  }, [trainingId, trainingCards]);

  if (loading) {
    return <div>Loading chart...</div>;
  }

  return (
    <div className="p-4 bg-white rounded-md mt-5" style={{ width: "100%", height: "400px" }}>
      <h3 className="text-lg font-bold mb-2">Training Gap Analysis</h3>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 50 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="questionNumber"
            angle={0}
            textAnchor="middle"
            label={{ value: "", position: "insideBottom", dy: 10 }}
          />
          <YAxis />
          <Tooltip content={({ payload }) => {
            if (!payload || payload.length === 0) return null;
            const { fullQuestion, Correct, Incorrect } = payload[0].payload;
            return (
              <div className="bg-white shadow-md p-2 rounded border">
                <p className="font-bold">{fullQuestion}</p>
                <p className="text-green-500">✅ Correct: {Correct}</p>
                <p className="text-red-500">❌ Incorrect: {Incorrect}</p>
              </div>
            );
          }} />
          <Legend />
          <Bar dataKey="Correct" stackId="a" fill="#4ade80" />
          <Bar dataKey="Incorrect" stackId="a" fill="#f87171" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrainingBarChart;
